import { render, staticRenderFns } from "./Open_relay.vue?vue&type=template&id=af2ade58"
import script from "./Open_relay.vue?vue&type=script&lang=js"
export * from "./Open_relay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports